<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">资金明细</span>
      </div>

      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <!--<el-col :span="6">
            <el-form-item label="账户类型" prop="saletype">
              <el-select v-model="queryForm.saleType" clearable placeholder="请选择类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="6">
            <el-form-item label="任务ID" prop="taskId">
              <el-input v-model="queryForm.taskId" placeholder="请输入任务ID"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单编号" prop="orderId">
              <el-input v-model="queryForm.orderId" placeholder="请输入订单编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商家账号" prop="shopInfo">
              <el-input v-model="queryForm.userName" placeholder="请输入商家账号"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="注册时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="店铺" prop="shopInfo">
            <el-select v-model="queryForm.shopInfo" clearable placeholder="请选择店铺">
                <el-option
                    v-for="item in allShops"
                    :key="item.id"
                    :label="item.shopName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="serialDate" label="时间" />
        <el-table-column prop="serialNumber" label="操作编号" />
        <el-table-column prop="serialTypeEnumStr" label="操作类型" />
        <el-table-column prop="remarksDetails" label="说明" width="300"/>
        <el-table-column prop="serialMoney" label="金额" />
        <el-table-column prop="balanceMoney" label="余额" />
        <el-table-column prop="accountType" width="120" label="账户类型" />
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {queryBusinessMoneyDetails} from "../../api/b2cbusiness/b2c_admin";
import {getShops} from "../../api/b2cbusiness/b2c_shopmanage";
import MinxinScroll from "@/components/MinxinScroll";
import qs from "qs";
import {getTokenUserId} from "@/lib/utils";

export default {
name: "SalemanCashDetailList",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      tableData:[],
      allShops:[],
      queryFormRefName:"queryForm",
      queryForm:{
        taskId: null,
        orderId: null,
        shopInfo: null,
        timeRange: []
      },
      tableHeight: 450,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  beforeMount() {
    getShops({shopNum:null,
      shopName:null,
      shopUsername:null,
      shopType: null,
      shopMajorTypeId:null,
      status:null,
      shopGroup:null}).then(res=>{
      if (res.success){
        console.log(res.data)
        this.allShops = res.data;
      }
    });
    this.getData();
  },
  methods: {
    importData(){
      window.open("https://api.weiquanai.com/accountchangerecords/exportbchangelogsdata?"+qs.stringify({
        userId: getTokenUserId(),
        taskId: this.queryForm.taskId,
        orderId: this.queryForm.orderId,
        shopInfo: this.queryForm.shopInfo,
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
    },
    getData(){
      queryBusinessMoneyDetails(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      })
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
